import { render, staticRenderFns } from "./IndividualCourseAverageInfoPanel.vue?vue&type=template&id=65ced2fc&scoped=true"
import script from "./IndividualCourseAverageInfoPanel.vue?vue&type=script&lang=js"
export * from "./IndividualCourseAverageInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./IndividualCourseAverageInfoPanel.vue?vue&type=style&index=0&id=65ced2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ced2fc",
  null
  
)

export default component.exports